var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStreamlineIconUiBrowserSlider({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.75.75h22.5v18H.75ZM7.5 22.5a.375.375 0 1 1-.375.375.375.375 0 0 1 .375-.375m4.5 0a.375.375 0 1 1-.375.375A.375.375 0 0 1 12 22.5m4.5 0a.375.375 0 1 1-.375.375.375.375 0 0 1 .375-.375",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.707 7.5 3.75 9.75 5.707 12m12.586-4.5 1.957 2.25L18.293 12",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineIconUiBrowserSlider);
export default __webpack_public_path__ + "static/media/streamline-icon-ui-browser-slider.b746e4bd.svg";
export { ForwardRef as ReactComponent };